import styled from 'styled-components';
import {arrowDown} from '../../../../../assets/symbols/symbols/Symbols.css';
import {getColor} from '../../../utils/themeUtils';
import {dFlexColumn, alignCenter, dFlexCenter} from '../../../../../globalVariables/GlobalFlex';

export const item = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    gap: var(--space-xs);
    flex-shrink: 0;
    width: var(--dimension-15);
    text-align: center;
    cursor: pointer;
    color: ${p => getColor(p.theme.isDarkMode)};
`;

export const circle = styled.div<{ $icon?: string; }>`
    width: var(--dimension-11);
    height: var(--dimension-11);
    ${dFlexCenter}
    border-radius: var(--radius-full);
    &::before {
        content: '';
        width: var(--dimension-5-5);
        height: var(--dimension-5-5);
        background-color: ${p => getColor(p.theme.isDarkMode)};
        -webkit-mask: url("${p => p.$icon}") center / contain no-repeat;
        mask: url("${p => p.$icon}") center / contain no-repeat;
    }
`;

export const label = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    line-height: 1;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-normal);
`;

export const arrow = styled.div`
    width: var(--dimension-3);
    height: var(--dimension-3);
    background-color: ${p => getColor(p.theme.isDarkMode)};
    -webkit-mask: url("${arrowDown}") center / contain no-repeat;
    mask: url("${arrowDown}") center / contain no-repeat;
`;
